import styled from "@emotion/styled";
import Box from "@mui/material/Box";
import ListItemText from "@mui/material/ListItemText";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";

import Cookies from "js-cookie";
import React from "react";
import {useLocation, useNavigate} from "react-router-dom";
import RU from "../../services/translation/ru.json";
import {translation} from "../../services/translation/translation";

export default function Menu() {
	let navigate = useNavigate();
	const [colorsBG, setColorsBG] = React.useState({
		companies: "#6b6d78",
		// cashRegisters: '#313238',
		users: "#313238",
	});
	const [dict, setDict] = React.useState(RU);
	const {pathname} = useLocation();

	React.useEffect(() => {
		if (Cookies.get("simpalsid.lang")) {
			setDict(translation(Cookies.get("simpalsid.lang")));
		} else {
			setDict(translation("ru"));
		}
	}, []);

	const setBGcolor = (target) => {
		let newColors = {};
		Object.keys(colorsBG).map((key) => {
			if (key === target) {
				newColors[key] = "#6b6d78";
			} else {
				newColors[key] = "#313238";
			}
		});
		setColorsBG(newColors);
	};

	return (
		<Box
			sx={{
				backgroundColor: "#313238",
				height: "99%",
				width: "9%",
				position: "fixed",
			}}
		>
			<Menus sx={{marginTop: 2}}>
				<MenuItem sx={{backgroundColor: colorsBG.companies}}>
					<ListItemText
						sx={{color: "#FFFFFF"}}
						onClick={() => {
							setBGcolor("companies");
							navigate("/acps");
						}}
					>
						EKassa
					</ListItemText>
				</MenuItem>

				<MenuItem selected={pathname === "/"} sx={{backgroundColor: colorsBG.companies}}>
					<ListItemText
						sx={{color: "#FFFFFF"}}
						onClick={() => {
							setBGcolor("companies");
							navigate("/");
						}}
					>
						{dict.organization}
					</ListItemText>
				</MenuItem>
				<MenuItem selected={pathname.includes("/user")} sx={{backgroundColor: colorsBG.companies}}>
					<ListItemText
						sx={{color: "#FFFFFF"}}
						onClick={() => {
							setBGcolor("users");
							navigate("/users");
						}}
					>
						{dict.users}
					</ListItemText>
				</MenuItem>
				<MenuItem selected={pathname === "/taxes"} sx={{backgroundColor: colorsBG.companies}}>
					<ListItemText
						sx={{color: "#FFFFFF"}}
						onClick={() => {
							setBGcolor("taxes");
							navigate("/taxes");
						}}
					>
						{dict.taxes_logs}
					</ListItemText>
				</MenuItem>


				<MenuItem sx={{backgroundColor: colorsBG.companies}}>
					<ListItemText
						sx={{color: "#FFFFFF"}}
						onClick={() => {
							setBGcolor("taxes");
							navigate("/acps/logs");
						}}
					>
						Logs
					</ListItemText>

				</MenuItem>


				{/* <MenuItem
        sx={{backgroundColor: colorsBG.cashRegisters}}
        >
          <ListItemText sx={{color: '#FFFFFF'}}
          onClick={() => { setBGcolor('cashRegisters'); navigate("/admin/cash-registers");}}>Cash registers</ListItemText>
        </MenuItem> */}
			</Menus>
		</Box>
	);
}


const Menus = styled(MenuList)`
	.MuiMenuItem-root {
		background-color: transparent !important;
	}

	.Mui-selected {
		background-color: #1976d2 !important;
	}
`;
